import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuCheckboxItem,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Settings, Edit, FileText, Navigation } from 'lucide-react';
import { useSelector } from 'react-redux';
import { selectSession } from '@client/model';
import { SessionType } from '@shared';

interface WizardAdminMenuProps {
  onOpenFormPreview: () => void;
  onOpenPreviousApplications: () => void;
  unrestrictedNavEnabled: boolean;
  onToggleUnrestrictedNav: (enabled: boolean) => void;
  hasPreviousApplications: boolean;
}

export function WizardAdminMenu({
  onOpenFormPreview,
  onOpenPreviousApplications,
  unrestrictedNavEnabled,
  onToggleUnrestrictedNav,
  hasPreviousApplications,
}: WizardAdminMenuProps) {
  const session = useSelector(selectSession);
  // Only render for wizard sessions
  if (session.sessionType !== SessionType.wizard) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
        >
          <Settings className="mr-2 h-4 w-4" />
          Admin Tools
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-56"
      >
        <DropdownMenuItem onClick={onOpenFormPreview}>
          <Edit className="mr-2 h-4 w-4" />
          Preview Changes
        </DropdownMenuItem>

        {hasPreviousApplications && (
          <DropdownMenuItem onClick={onOpenPreviousApplications}>
            <FileText className="mr-2 h-4 w-4" />
            Previous Form Submissions
          </DropdownMenuItem>
        )}

        <DropdownMenuSeparator />

        <DropdownMenuItem
          onClick={e => {
            e.preventDefault();
            onToggleUnrestrictedNav(!unrestrictedNavEnabled);
          }}
          className="flex items-center justify-between"
        >
          <div className="flex items-center">
            <Navigation className="mr-2 h-4 w-4" />
            Unrestricted Navigation
          </div>
          <div
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
              unrestrictedNavEnabled ? 'bg-primary' : 'bg-gray-300'
            }`}
          >
            <span
              className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
                unrestrictedNavEnabled ? 'translate-x-4' : 'translate-x-1'
              }`}
            />
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
